import React from 'react';
import { getAudioUploadMetadata } from './audioUploadMetadata';

// Maximum file size for generating previews (50MB)
// Larger files will skip preview generation to avoid browser crashes
const MAX_PREVIEW_SIZE = 50 * 1024 * 1024;

// function useGetImagePreviews() {
// return readerObject + fileObject
function asyncFunction(file, resolve) {
    const metadata = getAudioUploadMetadata(file);

    // Skip reading large files to avoid memory issues
    if (file.size > MAX_PREVIEW_SIZE) {
        let folderAndPreview = {
            reader: null, // No preview for large files
            file: file,
            isLargeFile: true,
            metadata
        };
        resolve(folderAndPreview);
        return;
    }

    let reader = new FileReader();
    reader.onloadend = () => {
        // console.log('are you so fast', reader);
        let folderAndPreview = {
            reader: reader,
            file: file,
            isLargeFile: false,
            metadata
        };
        resolve(folderAndPreview);
    };

    reader.onerror = () => {
        // On error, resolve without preview
        let folderAndPreview = {
            reader: null,
            file: file,
            isLargeFile: false,
            metadata
        };
        resolve(folderAndPreview);
    };

    reader.readAsDataURL(file);
}

const getImagePreviews = async files => {
    let requests = files.map(item => {
        return new Promise(resolve => {
            asyncFunction(item, resolve);
        });
    });

    return Promise.all(requests).then(res => {
        // console.log('done', res);
        return res;
    });
};

//     return [getImagePreviews]
// }

export default getImagePreviews;
